const initial = {
  orderDetails: {},
  orderLevelDetail: [],
  entryNumber: '',
  ticketResponse: {},
  success: '',
  failure: '',
  isLuxuryOrder: false,
  quesAnsDetail: []
};

function selfcare(state = {}, action) {
  switch (action.type) {
    case 'GET_ORDERS_DATA':
      return { ...state, orderDetails: action.orders };

    case 'GET_ORDER_SUCCESS':
      return { ...state, success: action.success };

    case 'GET_ORDER_FAIL':
      return { ...state, failure: action.success };

    case 'GET_ORDER_LEVEL_DETAIL':
      return {
        ...state,
        orderLevelDetail: action.orderLevelDetail,
        entryNumber: action.entryNumber
      };

    case 'GET_QUES_ANS_DETAIL':
      return {
        ...state,
        isLuxuryOrder: action.quesAnsDetailData.isLuxuryOrder,
        quesAnsDetail: action.quesAnsDetailData.quickLinksList
      };

    case 'GET_COMPLAINTS_LIST':
      return { ...state, complaintListResponse: action.complaintListResponse };

    case 'GET_INDIVIDUAL_COMPLAINTS_DETAILS':
      return { ...state, individualComplaintResponse: action.individualComplaintResponse };

    case 'FAQ_DATA_SUCCESS':
      return { ...state, faq: action.faq };

    case 'FAQ_SEARCH_DATA':
      return { ...state, faqSearch: action.faqSearch };

    case 'FAQ_SEARCH_SUCCESS':
      return { ...state, search_success: action.search_success };

    case 'FAQ_SEARCH_FAIL':
      return { ...state, search_success: action.search_success };

    case 'CLEAR_FAQ_SEARCH_DATA':
      return { ...state, faqSearch: [] };

    case 'SET_NO_SEARCH_RES':
      return { ...state, messObj: action.messObj };

    case 'CLEAR_SEARCH_MSG':
      return { ...state, messObj: [] };

    case 'CALL_ME_BACK_DATA_SUCCESS':
      return { ...state, callMeBack: action.callMeBackParam };

    case 'CALL_ME_BACK_SUBMIT_RESPONSE':
      return { ...state, callMeBackSubmitResponse: action.callMeBackParam };

    case 'CREATE_TICKET_RESPONSE':
      return { ...state, ticketResponse: action.ticketResponse };

    case 'HAPTIK_CHAT_AUTH_DATA_SUCCESS':
      return {
        ...state,
        haptikAuthDetails: { authCode: action.authCode, authId: action.authId, success: true }
      };

    case 'HAPTIK_CHAT_AUTH_DATA_FAIL':
      return {
        ...state,
        haptikAuthDetails: { success: false }
      };

    case 'HAPTIK_SIGNUP_SUCCESS':
      return {
        ...state,
        haptikSignedUp: true
      };

    case 'HAPTIK_SIGNUP_FAIL':
      return {
        ...state,
        haptikSignedUp: false
      };

    default:
      return state;
  }
}

export default selfcare;
